export const carrierTypeConstants = {
  MELROSE_ARCH: 'Personal Collection Melrose Arch',
  CAPE_QUARTER: 'Personal Collection Cape Quarter',
  FREE_DELIVERY: 'Free Delivery',
};
